import { useState } from "react";
import { Brain, LogOut, MessageSquare, MoreHorizontal, Pencil, Plus, Settings, Trash2, X } from "lucide-react";

import type { Chat } from "../types";

type Page = "chat" | "memory" | "settings";

type Props = {
  chats: Chat[];
  activeChatId: number | null;
  page: Page;
  open: boolean;
  onClose: () => void;
  onNewChat: () => void;
  onSelectChat: (id: number) => void;
  onPage: (page: Page) => void;
  onRename: (chat: Chat) => void;
  onDelete: (chat: Chat) => void;
  onLogout: () => void;
};

export function Sidebar(props: Props) {
  const [menuChat, setMenuChat] = useState<number | null>(null);
  return (
    <>
      {props.open && <button className="drawer-scrim" aria-label="Закрыть список чатов" onClick={props.onClose} />}
      <aside className={`sidebar ${props.open ? "open" : ""}`} aria-label="Основная навигация">
        <div className="brand-row">
          <span className="brand-mark" aria-hidden="true">S</span>
          <div className="brand-copy">
            <strong>SuperGPT</strong>
            <small>Личный помощник</small>
          </div>
          <button className="icon-button button-ghost mobile-only" type="button" aria-label="Закрыть" onClick={props.onClose}><X /></button>
        </div>

        <button className="button button-primary button-full new-chat-button" type="button" onClick={props.onNewChat}>
          <Plus /> Новый чат
        </button>

        <nav className="primary-nav" aria-label="Разделы">
          <button className={`nav-item ${props.page === "chat" ? "active" : ""}`} type="button" onClick={() => props.onPage("chat")}>
            <MessageSquare /> Чаты
          </button>
          <button className={`nav-item ${props.page === "memory" ? "active" : ""}`} type="button" onClick={() => props.onPage("memory")}>
            <Brain /> Память
          </button>
        </nav>

        <div className="chat-section">
          <p className="section-label">Чаты</p>
          <div className="chat-list">
            {props.chats.map((chat) => (
              <div className={`chat-row ${props.page === "chat" && chat.id === props.activeChatId ? "active" : ""}`} key={chat.id}>
                <button className="chat-select" type="button" onClick={() => props.onSelectChat(chat.id)}>
                  <span>{chat.title}</span>
                  <small>{chat.preview || "Пока нет сообщений"}</small>
                </button>
                <button className="icon-plain chat-menu-trigger" type="button" aria-label={`Действия с чатом ${chat.title}`} title="Действия" onClick={() => setMenuChat(menuChat === chat.id ? null : chat.id)}>
                  <MoreHorizontal />
                </button>
                {menuChat === chat.id && (
                  <div className="context-menu">
                    <button type="button" onClick={() => { props.onRename(chat); setMenuChat(null); }}><Pencil /> Переименовать</button>
                    <button className="danger" type="button" onClick={() => { props.onDelete(chat); setMenuChat(null); }}><Trash2 /> Удалить</button>
                  </div>
                )}
              </div>
            ))}
            {!props.chats.length && <p className="sidebar-empty">Чатов пока нет</p>}
          </div>
        </div>

        <div className="sidebar-footer">
          <button className={`nav-item ${props.page === "settings" ? "active" : ""}`} type="button" onClick={() => props.onPage("settings")}><Settings /> Настройки</button>
          <button className="nav-item" type="button" onClick={props.onLogout}><LogOut /> Выйти</button>
        </div>
      </aside>
    </>
  );
}

